<ng-content></ng-content>
<i class="ml-1 fa fa-caret-up" *ngIf="sortDirection === 'asc'" style="font-size: 20px;" ></i>
<i class="ml-1 fa fa-caret-down" *ngIf="sortDirection === 'desc'" style="font-size: 20px;" ></i>
